import React from "react";
import LoginComp from "@/components/LoginComp";
import WinToolbar from "@/layout/WinToolbar";
import { CloseCircleOutlined, GlobalOutlined, ExclamationCircleFilled } from "@/utils/antdIcon";
import { Button, Modal } from "antd";
import LeftSide from "@/components/LoginComp/LeftSide";
import { useTranslation } from "react-i18next";
import { UserState } from "@/models/user";
import { connect } from "dvajs";
import styles from "../components/LoginComp/index.module.less";

function LoginPage({
  showLogoutModalText,
  setShowLogoutModal
}: {
  showLogoutModalText: string;
  setShowLogoutModal: Function;
}) {
  const { t } = useTranslation("common");
  const confirm = () => {
    setShowLogoutModal("");
  };
  return (
    <div className={styles.loginPage}>
      <div
        style={{
          height: 40,
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          position: "fixed",
          top: "1px",
          left: 0,
          right: 0,
          zIndex: 10
        }}
      >
        <div className="draggable" id="draggable" style={{ height: 40, flex: 1 }} />
        <WinToolbar />
      </div>

      {/* <LeftSide /> */}
      <LoginComp />

      <Modal
        title={
          <div style={{ display: "flex", alignItems: "center" }}>
            <CloseCircleOutlined style={{ fontSize: "18px", color: "red", marginRight: "10px" }} />
            <div>{t("account-off-line")}</div>
          </div>
        }
        width={450}
        closable={false}
        visible={showLogoutModalText !== ""}
        maskClosable={false}
        keyboard={false}
        okText={t("button.ok")}
        footer={
          <Button type="primary" onClick={confirm}>
            {t("button.ok")}
          </Button>
        }
        zIndex={2000}
      >
        <p>{showLogoutModalText}</p>
      </Modal>
    </div>
  );
}
function mapStateToProps({ user }: any) {
  const { showLogoutModalText } = user as UserState;
  return {
    showLogoutModalText
  };
}

function mapDispatchToProps(dispatch: any) {
  return {
    setShowLogoutModal: (data: any) => {
      dispatch({ type: "user/setShowLogoutModal", payload: data });
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginPage);
